import * as React from 'react';

import { ContextService } from 'src/core/services/context.service';
import { CardController } from 'src/app/shared/card.controller';
import { ContactPartController } from 'src/app/crm/contacts/parts/contact-part.controller';

interface Props extends ComponentViewProps<ContactItem[]> {
	parentModel: ClientItem;
	contextService: ContextService;
	mode: ControlMode;
}

export const ClientContactPart = (props: Readonly<Props>) => {
	const { model, parentModel, mode, contextService, setBusy } = props;
	if (model == null) {
		return null;
	}

	return (
		<CardController
			title="Addresses"
			icon="contacts"
			className="card-borderless"
			mode={mode}>
			<ContactPartController
				model={model}
				parentModel={parentModel}
				mode={mode}
				setBusy={setBusy}
				contextService={contextService}
			/>
		</CardController>
	);
};



// WEBPACK FOOTER //
// ./src/app/crm/clients/form/parts/clientcontact-part.tsx